import axios from 'axios'

const domain = ""
// import themeConfig from '@/../themeConfig.js'


let headers = {
  'Content-Type':'application/json',
}
const token =localStorage.getItem("accessToken") || localStorage.accessToken;
if(token){
  headers['Authorization'] = 'Bearer '+token;
}

var myax= axios.create({
  baseURL: 'https://henzagold.shop/oapi/',
  headers:headers,
  domain
})

myax.interceptors.request.use(
  config => {
    config.headers["Authorization"] = "Bearer " + localStorage.getItem("accessToken");
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export default myax;
